@if (initialized) {
  <div class="start-media-overlay toggle-audio" (click)="toggleAudio($event)">
    <div class="audio-play-button">
      <mat-icon>{{ audioPlaying ? 'pause' : 'play_arrow'}}</mat-icon> {{ audioPlaying ? 'Pause' : 'Play' }} audio
    </div>
    <mat-slider
      class="audio-volume-slider"
      (click)="onAudioVolumeSliderClick($event)"
      [min]="0"
      [step]="0.01"
      [max]="1">
      <input matSliderThumb [(ngModel)]="audioVolume" (ngModelChange)="onVolumeChange($event)" />
    </mat-slider>
  </div>
} @else {
  <div class="start-media-overlay loading-indicator">
    <mat-spinner color="primary" [diameter]="18"></mat-spinner>
  </div>
}

